import React, { useEffect, useState } from "react";

function FullScreenCarousel({ slides, interval = 5000 }) {

    const [current, setCurrent] = useState(0);
    const [transition, setTransition] = useState(true);

    // Add first slide to the end
    const carouselSlides = [...slides, slides[0]];

    useEffect(() => {

        const timer = setInterval(() => {

            setCurrent((prev) => prev + 1);

        }, interval);

        return () => clearInterval(timer);

    }, [interval]);


    // When we reach the duplicate first slide,
    // instantly move back to the real first slide
    useEffect(() => {

        if (current === slides.length) {

            const timer = setTimeout(() => {

                setTransition(false);
                setCurrent(0);

            }, 1200);

            return () => clearTimeout(timer);
        }

    }, [current, slides.length]);


    // Turn the transition back on after the instant reset
    useEffect(() => {

        if (!transition) {

            const timer = setTimeout(() => {
                setTransition(true);
            }, 50);

            return () => clearTimeout(timer);
        }

    }, [transition]);


    return (
        <div
            style={{
                width: "100%",
                height: "100vh",
                overflow: "hidden",
                position: "relative"
            }}
        >

            <div
                style={{
                    display: "flex",
                    width: "100%",
                    height: "100%",

                    transform: `translateX(-${current * 100}%)`,

                    transition: transition
                        ? "transform 1.2s ease-in-out"
                        : "none"
                }}
            >

                {carouselSlides.map((slide, index) => (

                    <div
                        key={index}
                        style={{
                            minWidth: "100%",
                            height: "100%",
                            position: "relative",
                            flexShrink: 0,

                            backgroundImage: `url(${slide.image})`,
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                            backgroundRepeat: "no-repeat"
                        }}
                    >

                        <div
                            style={{
                                position: "absolute",
                                inset: 0,
                                background: "rgba(0, 0, 0, 0.25)"
                            }}
                        />

                        <div
                            style={{
                                position: "absolute",
                                inset: 0,
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center"
                            }}
                        >

                            <h1
                                style={{
                                    margin: 0,
                                    // color: "white",
                                    // fontFamily: "Anton, sans-serif",
                                    // fontSize: "5vw",
                                    textAlign: "center",
                                    zIndex: 2
                                }}
                            >
                                {slide.title}
                            </h1>

                        </div>

                    </div>

                ))}

            </div>

        </div>
    );
}

export default FullScreenCarousel;